import React, { FC } from "react";
import "./Checkbox.scss";

type CheckboxProps = {
  name?: string;
  isRequired?: boolean;
  isChecked?: boolean;
  isDark?: boolean;
};

const Checkbox: FC<CheckboxProps> = ({ name, isRequired, isChecked, isDark }) => {
  return (
    <input
      type="checkbox"
      name={name}
      id={name}
      required={isRequired}
      checked={isChecked}
      className={`checkbox cursor-click ${isDark ? 'is-dark' : ''}`}
      data-cursor-text="Select"
    />
  );
};

export default Checkbox;
